export const shortenAddress = (address: string, length = 7) => {
  const l = address.length;
  return `${address.substring(0, length)}...${address.substring(
    l - length,
    l
  )}`;
};
